import React from "react";
import "./Body.css";

import { Container, Row, Col } from "reactstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
library.add(faTimes, faCheck);

export default class Body extends React.Component {

  render() {

    return (
      <Container className="content-wrapper p-b-0">
        <Row className="top-banner">
          <Col md="6" className="left">
            <div>
              <p className="small-text">LET’S BUILD INTEGRATIONS THE RIGHT WAY</p>
              <h1>Integrate like a ninja, get certified</h1>
              <ul className="d-none d-sm-none d-md-block d-lg-block">
                <li>
                  <a className="int-btn blue-btn" href="#certificate-box-block">
                    Learn More
                  </a>
                </li>
                <li>
                  <a className="int-btn green-btn" href="#getcertified">Register for a certification</a>
                </li>
              </ul>
            </div>
          </Col>
          <Col md="6" className="right">
            <img
              className="img-fluid d-block mx-auto"
              src={require("../../img/get-certified.png")}
              alt="Integrator"
            />
          </Col>
          <ul className="d-lg-none d-md-none d-sm-block d-xs-block">
            <li>
              <a className="int-btn blue-btn" href="#certificate-box-block">
                Learn More
              </a>
            </li>
            <li>
              <a className="int-btn green-btn" href="#getcertified">Register for a certification</a>
            </li>
          </ul>
        </Row>
        <div className="under-banner">
          <h2 className="text-center">Stay up-to-date on the best practices in end-to-end integration and integration landscapes. Join the certified professionals building integrations faster and smarter.</h2>
          <div className="logo-b">
            <img
              className="img-fluid mx-auto d-block"
              src={require("../../img/ci_badge_small.png")}
              alt="Integrator logo"
            />
          </div>
          <h3 className="text-center" id="certificate-box-block">Why become a Certified Integrator?</h3>
        </div>
        <div className="row certificate-box-block">
          <Col md="6" className="certificate-box-left card">
            <Col className="card-body col">
              <h5 className="card-title">WITH CERTIFICATION</h5>
              <ul>
                <li>
                  <FontAwesomeIcon className="oi" icon="check" />
                  Get in control of distributed integration with standards to
                  ensure quality
                </li>
                <li>
                  <FontAwesomeIcon className="oi" icon="check" />
                  Confirmed knowledge of the 10 vitalities for an end-to-end
                  integration
                </li>
                <li>
                  <FontAwesomeIcon className="oi" icon="check" />
                  Knowledge about the five vitalities for a landscape of
                  integrations
                </li>
                <li>
                  <FontAwesomeIcon className="oi" icon="check" />
                  Skill & experience assessed in certification examination,
                  including case study
                </li>
              </ul>
            </Col>
          </Col>
          <Col md="6" className="certificate-box-right card">
            <Col className="card-body col">
              <h5 className="card-title">WITHOUT CERTIFICATION</h5>
              <ul>
                <li>
                  <FontAwesomeIcon className="oi" icon="times" />
                  Risk of a messy integration landscape and lots of headaches
                </li>
                <li>
                  <FontAwesomeIcon className="oi" icon="times" />
                  Less re-use, leading to longer time-to-market and higher cost
                </li>
                <li>
                  <FontAwesomeIcon className="oi" icon="times" />
                  Unsecure integrations with risk of exposing sensitive
                  information
                </li>
                <li>
                  <FontAwesomeIcon className="oi" icon="times" />
                  Lack of usable documentation, results in slower onboarding of
                  integrations and APIs
                </li>
              </ul>
            </Col>
          </Col>
        </div>
      </Container>
    );
  }
}